import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import Radar from 'radar-sdk-js';
import { RadarGeocodeLayer } from 'radar-sdk-js/dist/types';
import AutocompleteUI from 'radar-sdk-js/dist/ui/autocomplete';
import { BehaviorSubject } from 'rxjs';
import { LoggingService } from './logging.service';
export enum RadarAutocompleteUIState {
  Open,
  Closed
}
@Injectable({
  providedIn: 'root'
})
export class AutoCompleteService {
  private autoCompleteSubject = new BehaviorSubject<AutoCompleteResponse>(null);
  public autoComplete$ = this.autoCompleteSubject.asObservable(); 
  autocompleteUI: AutocompleteUI;
  private state: {id: string, state: RadarAutocompleteUIState}[];
  constructor(private logger: LoggingService) {
    const locationSearchState = this.state?.find(s => s.id === 'search');
    const homeSearchState = this.state?.find(s => s.id === 'home_search');
    
    if (!this.state?.length) {
      this.state = [
        { id: 'search', state: RadarAutocompleteUIState.Open },
        { id: 'home_search', state: RadarAutocompleteUIState.Open }
      ];
    } else if (locationSearchState) {
      locationSearchState.state = RadarAutocompleteUIState.Open;
    } else if (homeSearchState) {
      homeSearchState.state = RadarAutocompleteUIState.Open;
    }
  }
  public initializeAutoComplete(source: any, container = null) {
    setTimeout(() => {
      this.autocompleteUI = 
        Radar.ui.autocomplete({
          container: container ?? environment.RADAR.UI.container,
          showMarkers: environment.RADAR.UI.showMarkers,
          markerColor: environment.RADAR.UI.markerColor,
          responsive: environment.RADAR.UI.responsive,
          width: environment.RADAR.UI.width,
          maxHeight: environment.RADAR.UI.maxHeight,
          placeholder: environment.RADAR.UI.placeholder,
          limit: environment.RADAR.UI.limit,
          minCharacters: environment.RADAR.UI.minCharacters,
          layers: environment.RADAR.UI.layers as RadarGeocodeLayer[],
          countryCode:environment.RADAR.UI.countryCode,
          near: environment.RADAR.UI.near,
          hideResultsOnBlur: true,
          onSelection: (address) => {
            this.autoCompleteSubject.next({source: source, address: address});
          },
          onResults: () => {
            if(this.state.find(s => s.id == this.autocompleteUI.container.id)?.state == RadarAutocompleteUIState.Closed) {
              setTimeout(() => {
                this.autocompleteUI.close();
                this.autocompleteUI.clearResultsList();
              }, 100);            
              this.state.find(s => s.id == this.autocompleteUI.container.id).state = RadarAutocompleteUIState.Open;
            }
          },
          onError: (error) => {
            this.logger.logError(error);
          }
        });
    }, 200);
}
  public clearResults(targetId: string) {
    if(!this.isOpen()) { 
      this.setState(targetId, RadarAutocompleteUIState.Closed);
    }
  }
  private setState(targetId: string, state: RadarAutocompleteUIState) {
    const target = this.state.find(s => s.id == targetId);
    if(target) {
        target.state = state;
    } else {
      this.state.push({id: targetId, state: state});
    }
  }
  private isOpen() {
    return this.autocompleteUI?.isOpen ?? false;
  }
}

export interface RadarAddress {
  latitude?: number
  longitude?: number
  geometry?: Geometry
  country?: string
  countryCode?: string
  countryFlag?: string
  county?: string
  distance?: number
  city?: string
  neighborhood?: string
  postalCode?: string
  stateCode?: string
  state?: string
  street?: string
  layer?: string
  formattedAddress?: string
  addressLabel?: string
}
export interface Geometry {
  type?: string
  coordinates?: number[]
}
export interface AutoCompleteResponse {
  source: any;
  address: RadarAddress
}